import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import { BarnyardIcon } from 'barnyard/icons';
import AlertItem from './AlertItem';
import CredentialUnconnectedTable from './CredentialUnconnectedTable';


const CredentialUnconnectedAlert = ({ alert, ...other }) => (
  <AlertItem
    alert={alert}
    date={moment(alert.date).format('MMMM Do, YYYY')}
    icon={<BarnyardIcon icon={['fa', 'times']} className='DiscussCard__replyIcon dea' />}
    title={(
      <div>
        <Link to={`/corporate/analyze/buyer/${alert.buyer.id}`}>
          {alert.buyer.name}
        </Link>
        {' '} became unconnected from a vendor
      </div>
    )}
    content={(
      <CredentialUnconnectedTable
        includeExport={true}
        credentials={alert.value.credentials}
        buyerName={alert.buyer.name}
      />
    )}
    {...other}
  />
);

CredentialUnconnectedAlert.propTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default CredentialUnconnectedAlert;
